import { createContext, useContext } from "react";

export const MapLayerSelectedContext = createContext("default");

export function useSelectedMapLayerContext() {
  return useContext(MapLayerSelectedContext);
}
